export const REVIEW_REPLY_PRO_TOOLTIP = 'Pro experts can reply to client reviews.';

export interface ReviewReplyAccess {
  canReply: boolean;
  tooltip?: string;
}

/** `undefined` (status not loaded yet) locks the control without the upgrade prompt. */
export function getReviewReplyAccess(isPro: boolean | undefined): ReviewReplyAccess {
  if (isPro === true) return { canReply: true };
  if (isPro === false) return { canReply: false, tooltip: REVIEW_REPLY_PRO_TOOLTIP };
  return { canReply: false };
}
